import AccordionArea from './AccordionArea';

import useTranslation from '../../features/translation/hooks/useTranslation';
import './EntryPageList.scss';
import useAccordionItems from './useAccordionItems';
import { useAnalyticsHelpers } from '../../useAnalyticsHelpers';
import { useEffect } from 'react';

const EntryPageList: React.FC = () => {
  const t = useTranslation();
  const accordionItems = useAccordionItems();
  const { setFWALayerPageContentIds } = useAnalyticsHelpers();
  useEffect(() => {
    setFWALayerPageContentIds('select movement', 'select movement');
    // We need to only execute this once on page load, for not sending false positives to Econda
  }, []);

  return (
    <div className="entry-page-list container-fluid">
      <h2 className="fr-heading ems-entry-page--list-headline">{t('kindOfMovementNeed')}</h2>
      <AccordionArea group={accordionItems} />
    </div>
  );
};

export default EntryPageList;
